import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BasicFilters } from '../model/filters/basic-filters';
import { Observable } from 'rxjs';
import { DeviceCategoriesResponse } from '../model/responses/device-categories-response';
import { HttpUtils } from '../shared/http.utils';
import { DeviceCategoryPersistRequest } from '../model/requests/device-category-persist-request';

@Injectable({
  providedIn: 'root'
})
export class DeviceCategoriesService {

  private readonly deviceCategoriesURL: string;

  constructor(private http: HttpClient) {
    this.deviceCategoriesURL = '/catalog/device_categories';
  }

  public getDeviceCategories(offset?: number, limit?: number, filters?: BasicFilters): Observable<DeviceCategoriesResponse>{
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new BasicFilters();
    return this.http.post<DeviceCategoriesResponse>(this.deviceCategoriesURL, body, options);
  }

  public createDeviceCategory(deviceCategoryCreationData: DeviceCategoryPersistRequest): Observable<any> {
    const url = `${this.deviceCategoriesURL}/create`;
    return this.http.post<any>(url, deviceCategoryCreationData);
  }

  public editDeviceCategory(deviceCategoryCreationData: DeviceCategoryPersistRequest): Observable<any> {
    const url = `${this.deviceCategoriesURL}/edit`;
    return this.http.post<any>(url, deviceCategoryCreationData);
  }

  public deleteDeviceCategories(identifiers: {tenantUuid: string, name: string}[]): Observable<HttpResponse<any>> {
    const url = `${this.deviceCategoriesURL}/delete`;
    return this.http.post<any>(url, identifiers, {observe: 'response'});
  }

}
